import { forwardRef, cloneElement, isValidElement } from 'react';
import { getTabStyle, getIconStyle, getLabelStyle, COLORS } from './styles';

interface Tab {
  label: string;
  value: string;
  icon?: JSX.Element;
}

interface PillTabItemProps {
  tab: Tab;
  isActive: boolean;
  fullWidth?: boolean;
  onClick: () => void;
}

export const PillTabItem = forwardRef<HTMLDivElement, PillTabItemProps>(
  ({ tab, isActive, fullWidth, onClick }, ref) => {
    const handleKeyDown = (e: React.KeyboardEvent) => {
      if (e.key === 'Enter' || e.key === ' ') {
        onClick();
      }
    };

    const iconColor = isActive ? COLORS.active : COLORS.inactive;

    const renderIcon = () => {
      if (!tab.icon) return null;

      if (isValidElement(tab.icon)) {
        const iconProps = tab.icon.props as Record<string, any>;
        return cloneElement(tab.icon as React.ReactElement<any>, {
          style: {
            ...(iconProps?.style || {}),
            fill: iconColor,
            color: iconColor
          },
          fill: iconColor
        });
      }

      return tab.icon;
    };

    return (
      <div
        ref={ref}
        role="button"
        tabIndex={0}
        onClick={onClick}
        onKeyDown={handleKeyDown}
        style={getTabStyle(fullWidth)}>
        {tab.icon && <span style={getIconStyle(isActive)}>{renderIcon()}</span>}
        <span style={getLabelStyle(isActive)}>{tab.label}</span>
      </div>
    );
  }
);

PillTabItem.displayName = 'PillTabItem';
